module.exports = __webpack_public_path__ + "static/media/014ty@2x.6c590dcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/014ty@2x.png
// module id = 1661
// module chunks = 0 1